import { combineReducers } from 'redux';

import {
	RECEIVE_VIDEOS, 
	RECEIVE_APPLETV_VIDEOS,
	SET_SVOD_ENVIRONMENT,
	DISPLAY_DROPDOWN,
	REMOVE_DROPDOWN,
	NEW_ACTIVE_VIDEO,
	REMOVE_ACTIVE_VIDEO,
	UPDATE_WATCHLIST,
	TOGGLE_VOLUME,
	TOGGLE_SURVEY_ACTIVE,
	SET_PROFILE_PICTURE_NUMBER,
	NEW_SELECTED_ASSET_ROW,
	SET_CURATED_ROW,
	SET_TARGET_ASSET,
	NEW_SELECTED_ASSET,
	PREVIOUS_SELECTED_ASSET,
	UPDATE_VIDEO_PROGRESS,
	CLOSED_TARGET_ASSET,
} from '../actions/SVOD';

const videosReducer = (state = {}, action) => {
	Object.freeze(state);
	let newState = Object.assign({}, state);

	switch (action.type) {
		case RECEIVE_VIDEOS:{
			for (let i = 0; i < action.rows.length; i++) {
				let genre = `${action.rows[i].label}_${action.rows[i].id}`;
				if (action.rows[i].display_type.includes("billboard")) {
					genre = `Billboard_${action.rows[i].id}`;
				}
				else if (action.rows[i].display_type === "highlight") {
					genre = `Highlight_${action.rows[i].id}`;
				}
				else if (action.rows[i].display_type === "poster") {
					genre = `Poster_${action.rows[i].id}`;
				}

				let assets = action.rows[i].assets;
				let vidObj = {};
				for (let j = 0; j < assets.length; j++) {
					vidObj[assets[j]._id.valueOf()] = assets[j];
					// note: if two vids in the same row have the same id, only the last one will be included in final obj.
				}


				if (!(genre in newState)) {
					newState[genre] = vidObj;
				} else {
					newState[`${genre} I`] = vidObj;
				}
			}

			return newState;
		}
		default:
			return state;
	}
};

const appleTVVideosReducer = (state = {}, action) => {
	switch (action.type) {
		case RECEIVE_APPLETV_VIDEOS: {
			return action.appleTVVideos;
		}
		default:{
			return state;
		}
	}
};

const dropdownReducer = (state = {}, action) => {
	Object.freeze(state);

	switch (action.type) {
		case DISPLAY_DROPDOWN:
			return action.dropdown;

		case REMOVE_DROPDOWN:
			return {};

		default:
			return state;
	}
};

const activeVideoReducer = (state = {}, action) => {
	Object.freeze(state);

	switch (action.type) {
		case NEW_ACTIVE_VIDEO:
			return action.activeVideo;

		case REMOVE_ACTIVE_VIDEO:
			return {};

		default:
			return state;
	}
};

const selectedAssetReducer = (state = {}, action) => {
	Object.freeze(state);
	let newState = Object.assign({}, state);

	switch (action.type) {
		case NEW_SELECTED_ASSET:
			newState["asset"] = action.selectedAsset;
			return newState;
		case PREVIOUS_SELECTED_ASSET:
			newState["previousAsset"] = action.selectedAsset;
			return newState;
		case NEW_SELECTED_ASSET_ROW:
			newState["assetRow"] = action.selectedAssetRow;
			return newState;
		case SET_CURATED_ROW:
			newState["curatedRow"] = action.curatedRow;
			return newState;
		case SET_TARGET_ASSET:
			newState["targetAssetId"] = action.targetAssetId;
			return newState;

		default:
			return state;
	}
};

const watchlistReducer = (state = [], action) => {

	switch (action.type) {
		case UPDATE_WATCHLIST:
			return action.newWatchlist;

		default:
			return state;
	}
};

const volumeReducer = (state = { volume: false }, action) => {
	Object.freeze(state);
	let newState = Object.assign({}, state);

	switch (action.type) {
		case TOGGLE_VOLUME:
			newState.volume = action.volume;  
			return newState;

		default:
			return state;
	}
};

const activeSurveyReducer = (state = false, action) => {
	switch (action.type) {
		case TOGGLE_SURVEY_ACTIVE:
			return action.isSurveyActive;

		default:
			return state;
	}
};

const environmentReducer = (state = {}, action) => {

	switch (action.type) {
		case SET_SVOD_ENVIRONMENT:	
			return action.environment;

		default:
			return state;
	}
};

const profilePictureNumberReducer = (state = {}, action) => {
	switch (action.type) {
		case SET_PROFILE_PICTURE_NUMBER:
			return action.profilePictureNumber;

		default:
			return state;
	}
};

const videoProgressReducer = (state = {}, action) => {
	switch (action.type) {
		case UPDATE_VIDEO_PROGRESS:

			return action.newVideoProgressList;

		default:
			return state;
	}
};

const targetAssetStateReducer = (state = false, action) => {
	switch (action.type) {
		case CLOSED_TARGET_ASSET:
			return true;

		default:
			return state;
	}
};

const SVOD = combineReducers({
	videos: videosReducer,
	appleTVVideos: appleTVVideosReducer,
	dropdown: dropdownReducer,
	activeVideo: activeVideoReducer,
	watchlist: watchlistReducer,
	volume: volumeReducer,
	isSurveyActive: activeSurveyReducer,
	environment: environmentReducer,
	profilePictureNumber: profilePictureNumberReducer,
	selectedAssets: selectedAssetReducer,
	videoProgress: videoProgressReducer,
	closedTargetAsset: targetAssetStateReducer,
});

export default SVOD;


// WEBPACK FOOTER //
// ./src/redux/reducers/SVOD.js